<template>
  <div class="ai-business-page">
    <Header />

    <!-- Hero 区域 -->
    <section class="hero-section">
      <div class="hero-content">
        <div class="hero-text">
          <div class="hero-badge">
            <span>🤖 新一代人工智能解决方案</span>
          </div>
          <h1 class="hero-title">
            汇通 AI 业务<br />
            <span class="highlight">赋能企业智能化转型</span>
          </h1>
          <p class="hero-subtitle">
            基于先进的大模型技术，为企业提供海量智能体、数据服务与存算一体机<br />
            一站式 AI 基础设施，加速智能化升级
          </p>
          <div class="hero-ctas">
            <button class="btn-primary" @click="handleConsult">立即咨询</button>
            <button class="btn-secondary" @click="handleLearnMore">了解更多</button>
          </div>
        </div>
        <div class="hero-visual">
          <div class="main-circle">
            <img src="@/assets/images/generated-1772441615240.png" alt="AI 核心" class="center-icon" />
          </div>
          <div class="card-item card1">
          </div>
          <span class="card-label label1">智能体</span>
          <div class="card-item card2">
          </div>
          <span class="card-label label2">数据服务</span>
          <div class="card-item card3">
          </div>
          <span class="card-label label3">大模型</span>
          <div class="card-item card4">
          </div>
          <span class="card-label label4">AI 应用</span>
          <div class="orb orb1"></div>
          <div class="orb orb2"></div>
          <div class="orb orb3"></div>
          <div class="orb orb4"></div>
        </div>
      </div>
      <div class="bg-decoration bg1"></div>
      <div class="bg-decoration bg2"></div>
    </section>

    <!-- 三大业务方向 -->
    <section class="business-directions">
      <div class="container">
        <div class="section-header">
          <span class="section-label">核心业务</span>
          <h2 class="section-title">三大 AI 业务方向，构建完整智能生态</h2>
          <p class="section-desc">
            从智能交互到数据服务，再到算力基础设施，为企业提供全栈式 AI 能力
          </p>
        </div>
        <div class="cards-container">
          <div class="card card1">
            <div class="card-icon">
              <img src="@/assets/images/icon-agent.png" alt="智能体" />
            </div>
            <h3 class="card-title">海量智能体</h3>
            <p class="card-desc">
              基于大模型构建的海量智能体集群，<br />
              支持多场景、多行业的智能交互需求，<br />
              实现业务流程自动化
            </p>
            <div class="card-features">
              <div class="feature-item">• 多模态交互能力</div>
              <div class="feature-item">• 行业垂直场景覆盖</div>
              <div class="feature-item">• 智能体协同调度</div>
            </div>
          </div>
          <div class="card card2">
            <div class="card-icon">
              <img src="@/assets/images/icon-data.png" alt="数据服务" />
            </div>
            <h3 class="card-title">企业级数据服务</h3>
            <p class="card-desc">
              专业的企业数据资产管理平台，<br />
              提供数据采集、清洗、分析、治理全链路服务，<br />
              释放数据价值
            </p>
            <div class="card-features">
              <div class="feature-item">• 数据中台建设</div>
              <div class="feature-item">• 智能数据分析</div>
              <div class="feature-item">• 数据安全合规</div>
            </div>
          </div>
          <div class="card card3">
            <div class="card-icon">
              <img src="@/assets/images/icon-server.png" alt="一体机" />
            </div>
            <h3 class="card-title">存算大模型一体机</h3>
            <p class="card-desc">
              软硬件一体化 AI 算力解决方案，<br />
              预装大模型与智能体框架，<br />
              开箱即用，满足企业私有化部署需求
            </p>
            <div class="card-features">
              <div class="feature-item">• 高性能算力底座</div>
              <div class="feature-item">• 私有化模型部署</div>
              <div class="feature-item">• 开箱即用方案</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 海量智能体详情 -->
    <section class="detail-section agent-section">
      <div class="container">
        <div class="section-header">
          <span class="section-badge badge-agent">🤖 海量智能体</span>
          <h2 class="section-title">海量智能体</h2>
          <p class="section-desc">
            基于大模型构建的海量智能体集群，支持多场景、多行业的智能交互需求，实现业务流程自动化
          </p>
        </div>
        <div class="detail-content">
          <div class="detail-visual">
            <div class="visual-placeholder">
              <img src="@/assets/images/generated-1772432199400.png" alt="海量智能体" class="visual-img" />
            </div>
          </div>
          <div class="detail-features">
            <div class="detail-feature feature1">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772425752939.png" alt="多模态交互" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">多模态交互能力</h4>
                <p class="feature-text">支持文本、语音、图像多模态输入输出，智能体理解更精准，交互更自然</p>
              </div>
            </div>
            <div class="detail-feature feature2">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772425760953.png" alt="行业场景覆盖" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">行业垂直场景覆盖</h4>
                <p class="feature-text">金融、医疗、零售、制造等行业场景定制，智能体快速适配业务需求</p>
              </div>
            </div>
            <div class="detail-feature feature3">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772425767922.png" alt="智能体协同" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">智能体协同调度</h4>
                <p class="feature-text">海量智能体并行协作，任务自动分配与调度，复杂业务流程自动化</p>
              </div>
            </div>
            <div class="detail-feature feature4">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772425775040.png" alt="快速部署" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">快速部署与迭代</h4>
                <p class="feature-text">低代码智能体编排，模型快速微调，业务规则灵活配置与持续优化</p>
              </div>
            </div>
          </div>
        </div>
        <div class="flow-section">
          <h3 class="flow-title">智能体应用流程</h3>
          <div class="flow-steps">
            <div class="step step1">
              <div class="step-num">1</div>
              <h4 class="step-title">需求定义</h4>
              <p class="step-desc">场景分析</p>
            </div>
            <div class="step step2">
              <div class="step-num">2</div>
              <h4 class="step-title">智能体编排</h4>
              <p class="step-desc">低代码配置</p>
            </div>
            <div class="step step3">
              <div class="step-num">3</div>
              <h4 class="step-title">模型微调</h4>
              <p class="step-desc">场景适配</p>
            </div>
            <div class="step step4">
              <div class="step-num">4</div>
              <h4 class="step-title">部署上线</h4>
              <p class="step-desc">快速集成</p>
            </div>
            <div class="step step5">
              <div class="step-num">5</div>
              <h4 class="step-title">持续优化</h4>
              <p class="step-desc">数据反馈</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据服务详情 -->
    <section class="detail-section data-section">
      <div class="container">
        <div class="section-header">
          <span class="section-badge badge-data">📊 数据服务</span>
          <h2 class="section-title">企业级数据服务平台</h2>
          <p class="section-desc">
            一站式数据资产管理解决方案，从数据采集到智能分析，释放企业数据价值
          </p>
        </div>
        <div class="detail-content">
          <div class="detail-visual">
            <div class="visual-placeholder data-visual">
              <img src="@/assets/images/generated-1772415849136.png" alt="数据服务" class="visual-img" />
            </div>
          </div>
          <div class="detail-features">
            <div class="detail-feature feature1">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772420733746.png" alt="数据采集" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">全域数据采集</h4>
                <p class="feature-text">支持多源异构数据接入，数据库、API、文件、消息队列全覆盖</p>
              </div>
            </div>
            <div class="detail-feature feature2">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772420741228.png" alt="数据治理" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">智能数据治理</h4>
                <p class="feature-text">自动化数据清洗、标准化、去重，数据质量实时监控与预警</p>
              </div>
            </div>
            <div class="detail-feature feature3">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772420666796.png" alt="智能分析" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">AI 智能分析</h4>
                <p class="feature-text">自然语言查询数据，自动生成分析洞察，预测趋势辅助决策</p>
              </div>
            </div>
            <div class="detail-feature feature4">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772420675191.png" alt="安全合规" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">数据安全合规</h4>
                <p class="feature-text">多级权限管控、数据脱敏、审计追踪，满足等保及行业合规要求</p>
              </div>
            </div>
          </div>
        </div>
        <div class="flow-section">
          <h3 class="flow-title">数据服务全流程</h3>
          <div class="flow-steps">
            <div class="step step1">
              <div class="step-num">1</div>
              <h4 class="step-title">数据采集</h4>
              <p class="step-desc">多源接入</p>
            </div>
            <div class="step step2">
              <div class="step-num">2</div>
              <h4 class="step-title">数据清洗</h4>
              <p class="step-desc">智能治理</p>
            </div>
            <div class="step step3">
              <div class="step-num">3</div>
              <h4 class="step-title">数据存储</h4>
              <p class="step-desc">湖仓一体</p>
            </div>
            <div class="step step4">
              <div class="step-num">4</div>
              <h4 class="step-title">数据分析</h4>
              <p class="step-desc">智能洞察</p>
            </div>
            <div class="step step5">
              <div class="step-num">5</div>
              <h4 class="step-title">数据应用</h4>
              <p class="step-desc">价值释放</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 一体机详情 -->
    <section class="detail-section server-section">
      <div class="container">
        <div class="section-header">
          <span class="section-badge badge-server">🖥️ 算力底座</span>
          <h2 class="section-title">存算大模型一体机</h2>
          <p class="section-desc">
            软硬一体化 AI 算力基础设施，开箱即用，助力企业快速构建私有化 AI 能力
          </p>
        </div>
        <div class="detail-content server-content">
          <div class="detail-features server-features">
            <div class="detail-feature feature1">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772421180139.png" alt="高性能算力" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">高性能算力集群</h4>
                <p class="feature-text">搭载多卡 GPU 服务器，支持千亿级参数大模型推理，并发处理能力行业领先</p>
              </div>
            </div>
            <div class="detail-feature feature2">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772421187292.png" alt="开箱即用" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">开箱即用方案</h4>
                <p class="feature-text">预装主流大模型与智能体框架，无需复杂配置，插电即可开始 AI 应用开发</p>
              </div>
            </div>
            <div class="detail-feature feature3">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772421298893.png" alt="私有化部署" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">私有化部署</h4>
                <p class="feature-text">数据不出域，满足金融、政务等高安全场景需求，完全自主可控</p>
              </div>
            </div>
            <div class="detail-feature feature4">
              <div class="feature-icon">
                <img src="@/assets/images/generated-1772421306899.png" alt="弹性扩展" />
              </div>
              <div class="feature-content">
                <h4 class="feature-title">弹性扩展架构</h4>
                <p class="feature-text">支持集群横向扩展，按需增加算力节点，业务增长无后顾之忧</p>
              </div>
            </div>
          </div>
          <div class="detail-visual">
            <div class="visual-placeholder server-visual">
              <img src="@/assets/images/generated-1772416024977.png" alt="存算一体机" class="visual-img" />
            </div>
          </div>
        </div>
        <div class="specs-section">
          <h3 class="specs-title">技术规格</h3>
          <div class="specs-grid">
            <div class="spec-item">
              <span class="spec-num">8×</span>
              <h4 class="spec-label">高性能 GPU</h4>
              <p class="spec-desc">NVLink 高速互联</p>
            </div>
            <div class="spec-item">
              <span class="spec-num">2TB+</span>
              <h4 class="spec-label">内存容量</h4>
              <p class="spec-desc">ECC 数据保护</p>
            </div>
            <div class="spec-item">
              <span class="spec-num">100TB+</span>
              <h4 class="spec-label">存储空间</h4>
              <p class="spec-desc">NVMe 高速 SSD</p>
            </div>
            <div class="spec-item">
              <span class="spec-num">1000+</span>
              <h4 class="spec-label">并发用户</h4>
              <p class="spec-desc">稳定在线服务</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA 区域 -->
    <section class="cta-section">
      <div class="container">
        <div class="cta-content">
          <h2 class="cta-title">开启企业 AI 智能化之旅</h2>
          <p class="cta-desc">立即联系我们的 AI 专家团队，获取定制化解决方案</p>
          <div class="cta-buttons">
            <button class="btn-cta-primary" @click="handleConsult">立即咨询</button>
            <button class="btn-cta-secondary" @click="handleDemo">预约演示</button>
          </div>
          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-icon">📞</span>
              <span class="contact-text">400-xxx-xxxx</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon">✉️</span>
              <span class="contact-text">ai@skht.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import metaInfo from "@/common/util/metaInfo";

export default {
  name: 'BusinessAi',
  metaInfo: metaInfo.ai,
  components: {
    Header,
    Footer,
  },
  data() {
    return {};
  },
  methods: {
    handleConsult() {
      // 立即咨询
      console.log('立即咨询');
    },
    handleLearnMore() {
      // 了解更多
      console.log('了解更多');
    },
    handleDemo() {
      // 预约演示
      console.log('预约演示');
    }
  }
};
</script>

<style lang="less" scoped>
.ai-business-page {
  width: 100%;
}

.container {
  max-width: 1786px;
  margin: 0 auto;
  padding: 0 120px;
}

/* Hero 区域 */
.hero-section {
  width: 100%;
  height: 600px;
  background: #eaf1fa;
  position: relative;
  overflow: hidden;
}

.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 50px 120px;
  height: 100%;
}

.hero-text {
  width: 600px;
}

.hero-badge {
  display: inline-block;
  background: rgba(37, 99, 235, 0.1);
  border-radius: 20px;
  padding: 8px 16px;
  margin-bottom: 24px;

  span {
    color: #2563eb;
    font-size: 16px;
    font-weight: medium;
  }
}

.hero-title {
  font-size: 52px;
  font-weight: bold;
  color: #1e293b;
  line-height: 1.2;
  margin-bottom: 24px;

  .highlight {
    color: #3b82f6;
  }
}

.hero-subtitle {
  font-size: 18px;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 24px;
}

.hero-ctas {
  display: flex;
  gap: 16px;
}

.btn-primary, .btn-cta-primary {
  background: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 14px 32px;
  font-size: 18px;
  font-weight: semibold;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #2563eb;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  }
}

.btn-secondary {
  background: transparent;
  color: #3b82f6;
  border: 1px solid #3b82f6;
  border-radius: 8px;
  padding: 14px 32px;
  font-size: 18px;
  font-weight: semibold;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(59, 130, 246, 0.1);
  }
}

.btn-cta-secondary {
  background: transparent;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 16px 40px;
  font-size: 18px;
  font-weight: semibold;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #ffffff;
    background: rgba(255, 255, 255, 0.1);
  }
}

.hero-visual {
  width: 520px;
  height: 420px;
  position: relative;
}

.main-circle {
  width: 420px;
  height: 420px;
  border-radius: 210px;
  background: linear-gradient(135deg, #e0f2fe 0%, #dbeafe 50%, #bfdbfe 100%);
  position: absolute;
  left: 50px;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 0 80px rgba(59, 130, 246, 0.4),
    inset 0 0 80px rgba(59, 130, 246, 0.15);

  // 中心光晕效果
  &::before {
    content: '';
    position: absolute;
    width: 320px;
    height: 320px;
    border-radius: 160px;
    background: radial-gradient(circle, rgba(255,255,255,0.9) 0%, transparent 70%);
    z-index: 1;
  }

  // 外圈光晕
  &::after {
    content: '';
    position: absolute;
    width: 260px;
    height: 260px;
    border-radius: 130px;
    background: radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 60%);
    z-index: 1;
  }

  .center-icon {
    width: 200px;
    height: 200px;
    object-fit: contain;
    z-index: 2;
    filter: drop-shadow(0 0 40px rgba(59, 130, 246, 0.6));
    border-radius: 100px;
    background: radial-gradient(circle, rgba(255,255,255,0.8) 0%, transparent 60%);
  }
}

.card-item {
  width: 90px;
  height: 90px;
  border-radius: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);

  &.card1 {
    background-image: url('../../assets/images/generated-1772425752939.png');
    left: 20px;
    top: 20px;
    box-shadow: 0 4px 20px rgba(59, 130, 246, 0.4);
  }

  &.card2 {
    background-image: url('../../assets/images/generated-1772425760953.png');
    right: 20px;
    top: 20px;
    box-shadow: 0 4px 20px rgba(139, 92, 246, 0.4);
  }

  &.card3 {
    background-image: url('../../assets/images/generated-1772425767922.png');
    left: 20px;
    bottom: 20px;
    box-shadow: 0 4px 20px rgba(6, 182, 212, 0.4);
  }

  &.card4 {
    background-image: url('../../assets/images/generated-1772425775040.png');
    right: 20px;
    bottom: 20px;
    box-shadow: 0 4px 20px rgba(245, 158, 11, 0.4);
  }
}

.card-label {
  position: absolute;
  font-size: 12px;
  font-weight: medium;
  text-align: center;
  width: 80px;

  &.label1 {
    color: #3b82f6;
    left: 20px;
    top: 115px;
  }

  &.label2 {
    color: #8b5cf6;
    right: 20px;
    top: 115px;
  }

  &.label3 {
    color: #0891b2;
    left: 20px;
    bottom: 115px;
  }

  &.label4 {
    color: #f59e0b;
    right: 20px;
    bottom: 115px;
  }
}

.orb {
  position: absolute;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.3);

  &.orb1 {
    width: 10px;
    height: 10px;
    left: 0;
    top: 50%;
  }

  &.orb2 {
    width: 8px;
    height: 8px;
    right: 0;
    top: 20%;
  }

  &.orb3 {
    width: 12px;
    height: 12px;
    left: 10%;
    top: 0;
  }

  &.orb4 {
    width: 9px;
    height: 9px;
    right: 15%;
    bottom: 0;
  }
}

.bg-decoration {
  position: absolute;
  border-radius: 50%;

  &.bg1 {
    width: 300px;
    height: 300px;
    background: rgba(59, 130, 246, 0.05);
    left: -100px;
    top: -100px;
  }

  &.bg2 {
    width: 200px;
    height: 200px;
    background: rgba(59, 130, 246, 0.03);
    right: 100px;
    bottom: 100px;
  }
}

/* 三大业务方向 */
.business-directions {
  width: 100%;
  background: #ffffff;
  padding: 80px 0;
}

.section-header {
  text-align: center;
  padding: 0 200px;
  margin-bottom: 48px;
}

.section-label {
  display: inline-block;
  color: #3b82f6;
  font-size: 14px;
  font-weight: semibold;
  letter-spacing: 2px;
  margin-bottom: 16px;
}

.section-title {
  font-size: 40px;
  font-weight: bold;
  color: #1e293b;
  margin-bottom: 16px;
}

.section-desc {
  font-size: 18px;
  color: #64748b;
  line-height: 1.6;
}

.cards-container {
  display: flex;
  justify-content: center;
  gap: 24px;
}

.card {
  width: 360px;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }

  .card-icon {
    width: 64px;
    height: 64px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: flex-start;

    img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }
  }

  .card-title {
    align-self: flex-start;
    text-align: left;
  }

  .card-desc {
    align-self: flex-start;
    text-align: left;
  }

  .card-features {
    align-self: flex-start;
    width: 100%;

    .feature-item {
      text-align: left;
    }
  }
}

.card1 .card-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
}

.card2 .card-icon {
  background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
}

.card3 .card-icon {
  background: linear-gradient(135deg, #06b6d4 0%, #22d3ee 100%);
}

/* 详情模块通用样式 */
.detail-section {
  width: 100%;
  padding: 80px 0;
}

.agent-section {
  background: #f8fafc;
}

.data-section {
  background: #ffffff;
}

.server-section {
  background: #f0fdff;
}

.detail-content {
  display: flex;
  justify-content: center;
  gap: 48px;
  margin-top: 48px;

  &.server-content {
    flex-direction: row-reverse;
  }
}

.detail-visual {
  width: 520px;

  .visual-placeholder {
    width: 520px;
    height: 400px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;

    .visual-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &::before {
      content: '';
      position: absolute;
      width: 200px;
      height: 200px;
      background: rgba(59, 130, 246, 0.1);
      border-radius: 50%;
      top: 50px;
      left: 50px;
      pointer-events: none;
    }

    &::after {
      content: '';
      position: absolute;
      width: 150px;
      height: 150px;
      background: rgba(139, 92, 246, 0.1);
      border-radius: 50%;
      bottom: 50px;
      right: 50px;
      pointer-events: none;
    }

    &.data-visual {
      background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);

      &::before {
        background: rgba(139, 92, 246, 0.1);
      }

      &::after {
        background: rgba(168, 85, 247, 0.1);
      }
    }

    &.server-visual {
      background: linear-gradient(135deg, #ecfeff 0%, #cffafe 100%);

      &::before {
        background: rgba(6, 182, 212, 0.1);
      }

      &::after {
        background: rgba(8, 145, 178, 0.1);
      }
    }
  }
}

.detail-features {
  width: 520px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &.server-features {
    margin-right: 48px;
  }
}

.detail-feature {
  display: flex;
  gap: 16px;
  padding: 20px;
  border-radius: 12px;
  align-items: flex-start;

  &.feature1 {
    background: #eff6ff;
  }

  &.feature2 {
    background: #faf5ff;
  }

  &.feature3 {
    background: #ecfeff;
  }

  &.feature4 {
    background: #fef3c7;
  }

  .feature-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
  }

  .feature-content {
    flex: 1;
  }

  .feature-title {
    font-size: 17px;
    font-weight: semibold;
    color: #1e293b;
    margin-bottom: 4px;
  }

  .feature-text {
    font-size: 13px;
    color: #64748b;
    line-height: 1.5;
  }
}

/* 流程步骤 */
.flow-section {
  margin-top: 48px;
  text-align: center;
}

.flow-title {
  font-size: 22px;
  font-weight: bold;
  color: #1e293b;
  margin-bottom: 20px;
}

.flow-steps {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.step {
  width: 180px;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  &.step1 {
    background: #eff6ff;

    .step-num {
      background: #3b82f6;
    }
  }

  &.step2 {
    background: #f5f3ff;

    .step-num {
      background: #8b5cf6;
    }
  }

  &.step3 {
    background: #ecfeff;

    .step-num {
      background: #06b6d4;
    }
  }

  &.step4 {
    background: #fff7ed;

    .step-num {
      background: #f97316;
    }
  }

  &.step5 {
    background: #f0fdf4;

    .step-num {
      background: #22c55e;
    }
  }

  .step-num {
    width: 36px;
    height: 36px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
  }

  .step-title {
    font-size: 15px;
    font-weight: semibold;
    color: #1e293b;
  }

  .step-desc {
    font-size: 12px;
    color: #64748b;
  }
}

/* 技术规格 */
.specs-section {
  margin-top: 48px;
  text-align: center;
}

.specs-title {
  font-size: 22px;
  font-weight: bold;
  color: #1e293b;
  margin-bottom: 20px;
}

.specs-grid {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.spec-item {
  width: 200px;
  padding: 24px;
  background: #ecfeff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  .spec-num {
    font-size: 36px;
    font-weight: bold;
    color: #0891b2;
  }

  .spec-label {
    font-size: 15px;
    font-weight: medium;
    color: #1e293b;
  }

  .spec-desc {
    font-size: 12px;
    color: #64748b;
  }
}

/* Section Badge 样式 */
.section-badge {
  display: inline-block;
  border-radius: 16px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: medium;
  margin-bottom: 16px;

  &.badge-agent {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
  }

  &.badge-data {
    background: rgba(139, 92, 246, 0.1);
    color: #8b5cf6;
  }

  &.badge-server {
    background: rgba(6, 182, 212, 0.1);
    color: #0891b2;
  }
}

/* CTA 区域 */
.cta-section {
  width: 100%;
  background: #0a1628;
  padding: 80px 0;
}

.cta-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.cta-title {
  font-size: 52px;
  font-weight: bold;
  color: #ffffff;
}

.cta-desc {
  font-size: 20px;
  color: #cbd5e1;
  line-height: 1.6;
}

.cta-buttons {
  display: flex;
  gap: 16px;
}

.contact-info {
  display: flex;
  gap: 48px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;

  .contact-icon {
    font-size: 20px;
  }

  .contact-text {
    font-size: 16px;
    color: #94a3b8;
  }
}
</style>
